import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { initGTM, disableGTM } from '../utils/gtm';

const CookieConsent: React.FC = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already consented
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
    // Initialize and enable GTM tracking
    initGTM();
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
    // Disable GTM tracking and clear cookies
    disableGTM();
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white dark:bg-neutral-dark-200 border-t-2 border-primary-indigo dark:border-primary-rose shadow-2xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-neutral-900 dark:text-neutral-dark-900 mb-2">
              We value your privacy
            </h3>
            <p className="text-sm text-neutral-600 dark:text-neutral-dark-600 leading-relaxed">
              We use cookies to improve your experience on our site and to show you relevant advertising.
              By clicking "Accept", you consent to the use of all cookies. You can manage your preferences or
              learn more in our{' '}
              <Link
                to="/privacy-policy"
                className="text-primary-indigo dark:text-primary-rose underline hover:no-underline"
              >
                Privacy Policy
              </Link>.
            </p>
          </div>
          <div className="flex items-center gap-3 flex-shrink-0">
            <button
              onClick={handleDecline}
              className="px-6 py-3 min-h-[44px] text-sm font-medium text-neutral-700 dark:text-neutral-dark-700 bg-neutral-100 dark:bg-neutral-dark-300 rounded-lg hover:bg-neutral-200 dark:hover:bg-neutral-dark-400 transition-colors focus:outline-none focus:ring-2 focus:ring-neutral-400 focus:ring-offset-2"
            >
              Decline
            </button>
            <button
              onClick={handleAccept}
              className="px-6 py-3 min-h-[44px] text-sm font-medium text-white bg-primary-indigo dark:bg-primary-rose rounded-lg hover:bg-primary-indigo/90 dark:hover:bg-primary-rose/90 transition-colors focus:outline-none focus:ring-2 focus:ring-primary-indigo focus:ring-offset-2"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
